import { SET_BENCHMARK_DATA } from './benchmarkActions';

export const INITIAL_STATE = {
  localUserStatus: null,
  associacoes: [],
  carregando: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_BENCHMARK_DATA:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
